import { Pipe, PipeTransform } from '@angular/core';
import { Mediaclip } from 'app/interfaces/mediaclip';


@Pipe({name: 'fonts'})

export class FontsPipe implements PipeTransform {
	transform(input: string, clip: Mediaclip, baseUrl: string): string {
		if (clip && clip.assets && clip.assets.length > 0) {
			const assets = clip.assets;
			const fontAssetsArray: string[] = [];
			for (let i = 0; i < assets.length; i++) {
				if (assets[i].src) {
					const fontAsset = `url(${baseUrl}${assets[i].src}) format('${assets[i].mediatype}')`;
					fontAssetsArray.push(fontAsset);
				}
			}
			const fontAssets = fontAssetsArray.join();
			const newStyle = document.createElement('style');
			newStyle.appendChild(document.createTextNode(
				`@font-face {font-family: 'bb-select-${input}';
				src: ${fontAssets}}`
			));
			document.head.appendChild(newStyle);
			return input;
		} else {
			return input;
		}
	}
}
